/*
 * @Author: chenmengnan chenmengnan@piesat.cn
 * @Date: 2024-01-26 13:09:11
 * @LastEditors: chenmengnan
 * @LastEditTime: 2026-07-14 10:40:57
 * @FilePath: \web\src\api\policy\index.js
 * @Description:
 *
 */
import axios from '@/utils/request';
import config from '@/config/config';
import qs from 'qs';

/** 分页查询矿政资讯 */
export const getInformationPageApi = (params) => {
  return axios.post(`/bigdata/news/page`, params);
};
/** 新增矿政资讯 */
export const saveInformationPageApi = (body, params) => {
  // return axios.post(`/bigdata/news/save`, qs.stringify(params));
  return axios.post(`/bigdata/news/save?${qs.stringify(params)}`, body);
};
/** 编辑矿政资讯 */
export const updateInformationPageApi = (body, params) => {
  // return axios.put(`/bigdata/news/update`, qs.stringify(params));
  return axios.put(`/bigdata/news/update?${qs.stringify(params)}`, body);
};
/** 删除矿政资讯 */
export const deleteInformationPageApi = (data) => {
  return axios.delete(`/bigdata/news/delete`, { data });
};

/** 根据大洲id,国家地区指南列表 */
export const getGuidePageApi = (params) => {
  return axios.get(`/bigdata/guide/page`, { params });
};

/** 根据大洲id,国家地区指南列表-管理 */
export const getInvestPageApi = (params) => {
  return axios.post(`/bigdata/guide/totalPage`, params);
};

/** 保存 */
export const saveGuideApi = (body, params) => {
  return axios.post(`/bigdata/guide/save?${qs.stringify(params)}`, body);
};
/** 删除 */
export const deleteGuideApi = (data) => {
  return axios.delete(`/bigdata/guide/delete`, { data });
};
/** 编辑 */
export const editGuideApi = (body, params) => {
  return axios.post(`/bigdata/guide/update?${qs.stringify(params)}`, body);
};

/** 政策法规列表 */
export const getLawPageApi = (params) => {
  // return axios.post(`/bigdata/law/list`, params);
  return axios.post(`/bigdata/policies/totalPage`, params);
};
/** 政策法规保存 */
export const saveLawApi = (body, params) => {
    return axios.post(`/bigdata/policies/save?${qs.stringify(params)}`, body);
  // return axios.post(`/bigdata/law/save?${qs.stringify(params)}`, body);
};
/** 政策法规编辑 */
export const updateLawApi = (body, params) => {
    return axios.post(`/bigdata/policies/update?${qs.stringify(params)}`, body);
  // return axios.put(`/bigdata/law/update?${qs.stringify(params)}`, body);
};
/** 政策法规删除 */
export const deleteLawApi = (data) => {
    return axios.delete(`/bigdata/policies/delete`, { data });
  // return axios.delete(`/bigdata/law/delete`, { data });
};
/** 指南获取预览图片 */
export const getImgAddrApi = (params) => {
  return axios.post(`/bigdata/guide/report/overview`, params);
};

/** 政策法规获取预览图片 */
export const getLawImgAddrApi = (params) => {
  return axios.post(`/bigdata/policies/report/overview`, params);
};


/** 政策法规报告下载 */
export const getGuideDownApi = (
  params,
  type,
  option = {
    responseType: 'blob',
  },
) => axios.post(`/bigdata/guide/report/download?check=${type}`, params, { ...option });
